//---APP
export const APP_URLPARAMS_SET = 'APP_URLPARAMS_SET';
export const APP_LOADER_FLAG_TOGGLE = 'APP_LOADER_FLAG_TOGGLE';
export const APP_CONTENT_SET = 'APP_CONTENT_SET';
export const APP_MESSAGE_SET = 'APP_MESSAGE_SET';

//---SEARCH
export const SEARCH_QUERY_SET = 'SEARCH_QUERY_SET';

//---ANALYSIS
export const ANALYSIS_SET = 'ANALYSIS_SET';

//---CONTACTS
export const CONTACTS_SET = 'CONTACTS_SET';

//---REPORT
export const REPORT_SET = 'REPORT_SET';

//---CLIENT
export const CLIENT_SET = 'CLIENT_SET';
export const CLIENT_USER_PAYMENT_SET = 'CLIENT_USER_PAYMENT_SET';
export const CLIENT_USER_UPDATED_PAYMENT_SET = 'CLIENT_USER_UPDATED_PAYMENT_SET';
export const CLIENT_USER_CHARGE_SET = 'CLIENT_USER_CHARGE_SET';